import type { Result } from "@zxing/library";
import { useTranslation } from "react-i18next";
import BarcodeScanner from "react-qr-barcode-scanner";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const ScannerModal = ({
  isOpen,
  onOpenChange,
  onScanResult,
  onScanError,
  stopStream,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onScanResult: (error: unknown, result?: Result) => void;
  onScanError: (error: string | DOMException) => void;
  stopStream: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("scanner.title")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center space-y-4">
          <div className="w-full max-w-sm">
            <BarcodeScanner
              facingMode="environment"
              height={300}
              onError={onScanError}
              onUpdate={onScanResult}
              stopStream={stopStream}
              width="100%"
            />
          </div>
          <Button onClick={() => onOpenChange(false)} variant="outline">
            {t("labels.cancel")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
